import Vue from 'vue';
import {getPluginConfig} from "../start-ui";

let config = getPluginConfig('i18n');

export default {
    namespaced: true,

    state: {
        locales: {},
        currentLocale: config.locale,
    },

    mutations: {
        setCurrentLocale(state, locale) {
            Vue.set(state, 'currentLocale', locale);
        },

        import(state, {locale, data}) {
            if (!state.locales.hasOwnProperty(locale)) {
                Vue.set(state.locales, locale, {});
            }
            for (let [ns, translations] of Object.entries(data)) {
                for (let [key, value] of Object.entries(translations)) {
                    Vue.set(state.locales[locale], `${ns}/${key}`, value);
                }
            }
        },

        set(state, {key, value, locale = null}) {
            locale = locale || state.currentLocale;

            if (!key.includes('/')) {
                key = `default/${key}`;
            }
            if (!state.locales.hasOwnProperty(locale)) {
                Vue.set(state.locales, locale, {});
            }

            Vue.set(state.locales[locale], key, value);
        },
    },

    getters: {
        getCurrentLocale(state) {
            return state.currentLocale;
        },

        get(state) {
            return (key, params = {}, locale = null) => {
                locale = locale || state.currentLocale;

                if (!state.locales.hasOwnProperty(locale)) {
                    return '';
                }
                if (Array.isArray(key)) {
                    key = `${key[0]}/${key[1]}`;
                }
                if (!key.includes('/')) {
                    key = `default/${key}`;
                }

                if (key.endsWith('/')) {
                    return Object.keys(state.locales[locale]).reduce((result, k) => {
                        if (k.startsWith(key)) {
                            result[k.replace(key, '')] = state.locales[locale][k];
                        }
                        return result;
                    }, {});
                }

                if (!state.locales[locale].hasOwnProperty(key)) {
                    return '';
                }

                let value = state.locales[locale][key];
                if (value instanceof Function) {
                    value = value(params);
                }
                return value;
            };
        },
    },
};